// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611040014/js/" + chunkId + "." + {"44":"68941fa9","225":"d1990247","481":"42d93779","486":"8ffffd7d","770":"cdc5efd9"}[chunkId] + ".0.7323721168235312.chunk.js";
};